import { useNumericParams } from '@domain-group/react-hooks'

import PageContent from './components/PageContent'

const SalesforceDetails = () => {
  const { agencyId } = useNumericParams()

  return <PageContent agencyId={agencyId} />
}

export default SalesforceDetails
